<template>
  <div class="card card-hover">
    <div class="flex-between">
      <div class="flex items-center flex-1">
        <div class="flex-col mr-4" style="min-width: 60px;">
          <span class="text-base font-medium">{{ payTime }}</span>
          <span class="text-sm text-gray mt-2">{{ payDate }}</span>
        </div>
        <div class="flex-col flex-1">
          <div class="flex items-center">
            <span class="p-4 text-sm text-primary"
              style="background: #f0f2ff; border-radius: 4px; margin-right: 8px;">{{ statement.category }}</span>
            <span class="text-sm text-gray">{{ statement.payCategoryStr }}</span>
          </div>
          <div class="flex mt-4" v-if="hasCard">
            <span class="text-sm text-gray mr-4">卡号: {{ statement.cardConsumeContent.cardNumber }}</span>
            <span class="text-sm text-gray">余额: {{ cardBalance }}{{ statement.unit }}</span>
          </div>
        </div>
      </div>
      <div class="text-xl text-right" style="min-width: 80px;">
        <strong :class="amountClass">{{ showAmount }}{{ statement.unit }}</strong>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import jsUtil from "@/global/jsUtil";

const props = defineProps({
  statement: Object
});

const payTime = computed(() => {
  const now = new Date();
  const ss = new Date(props.statement.time);
  let date = "";
  if (
    now.getFullYear() === ss.getFullYear() &&
    now.getMonth() === ss.getMonth() &&
    now.getDate() === ss.getDate()
  ) {
    date = "今天";
  } else if (
    now.getFullYear() === ss.getFullYear() &&
    now.getMonth() === ss.getMonth() &&
    now.getDate() === ss.getDate() + 1
  ) {
    date = "昨天";
  } else {
    date = jsUtil.formatDate(props.statement.time);
  }

  const time = jsUtil.formatTime(props.statement.time);

  return date;
});

const payDate = computed(() => {
  const now = new Date();
  const ss = new Date(props.statement.time);
  let date = "";
  if (
    now.getFullYear() === ss.getFullYear() &&
    now.getMonth() === ss.getMonth() &&
    now.getDate() === ss.getDate()
  ) {
    date = "今天";
  } else if (
    now.getFullYear() === ss.getFullYear() &&
    now.getMonth() === ss.getMonth() &&
    now.getDate() === ss.getDate() + 1
  ) {
    date = "昨天";
  } else {
    date = jsUtil.formatDate(props.statement.time);
  }

  const time = jsUtil.formatTime(props.statement.time);

  return time;
});

const hasCard = computed(() => props.statement.cardConsumeContent != null);

const amountClass = computed(() => {
  if (props.statement.amount > 0) {
    return "positiveAmount";
  } else {
    return "negativeAmount";
  }
});

const showAmount = computed(() => {
  if (props.statement.amount > 0) {
    return "+" + props.statement.amount;
  } else {
    return props.statement.amount;
  }
});

const cardBalance = computed(() => {
  if (props.statement.cardConsumeContent) {
    return props.statement.cardConsumeContent.cardChargeAmount + props.statement.cardConsumeContent.cardGiveAmount;
  }
  return 0;
});
</script>

<style>
/* 仅保留特定样式 */
.positiveAmount {
  color: var(--success-color, #27ae60);
}

.negativeAmount {
  color: var(--danger-color, #e74c3c);
}
</style>